// extracted by mini-css-extract-plugin
export default {"backButton":"mmvU7NxYbXcrc938iMEf"};